import {AfterViewInit, Directive, ElementRef, HostListener, Input, OnChanges, OnInit, Renderer, ViewChild} from '@angular/core';
import {NgControl} from '@angular/forms';
import {CurrencyPipe, DecimalPipe} from '@angular/common';
declare const $: any;
@Directive({
  selector: '[appCurrency]'
})
export class CurrencyDirective implements OnChanges, OnInit, AfterViewInit {
  @Input('appCurrency') type = null;
  @Input() fontS= null;
  @Input() decimalS= null;
  protected value = '';
  @ViewChild('cl') element: ElementRef;
  constructor(private ctrl: NgControl, private decimalCurrent: DecimalPipe, private currency: CurrencyPipe,
              private el: ElementRef, private ren: Renderer) {
    this.el.nativeElement.style.color = 'transparent';
    this.el.nativeElement.style.backgroundColor = 'transparent';
    this.el.nativeElement.style.position = 'absolute';
    const fontsize = (this.fontS === null) ? '0.8rem' : this.fontS;
    this.el.nativeElement.style.fontSize = fontsize;
    $(this.el.nativeElement)
      .after('<div class="input_formatted" style=" ' + fontsize + ';' +
        'background: transparent; width:auto; text-align: right; padding-right: 4px; padding-top: 7px"></div>');
  }
  ngOnInit(): void {
    this.assignFormat(this.ctrl.value);
  }
  ngAfterViewInit(): void {
    this.ctrl.valueChanges.subscribe((data) => {
        this.assignFormat(data);
      }
    );
  }

  assignFormat(value) {
    $(this.el.nativeElement).next('.input_formatted').html(this.pipe(value));
  }

  @HostListener('change') ngOnChanges(): void {

  }
  @HostListener('focus')
  @HostListener('click') onClick() {
    this.showInputData();
  }
  @HostListener('blur') onBlur() {
    $(this.el.nativeElement).next('.input_formatted').show();
    this.el.nativeElement.style.color = 'transparent';
  }
  showInputData() {
    $(this.el.nativeElement).next('.input_formatted').hide();
    this.el.nativeElement.style.color = 'black';
  }
  pipe(value) {
    const decimalCode = this.decimalS ? this.decimalS + '-' + this.decimalS : '2-2';
    return  (!isNaN(parseFloat(value))) ?
      (
        ( this.type === 'USD' ) ?
          this.currency.transform(value, 'USD') :
          (
            ( this.type === '$' ) ?
              this.currency.transform(value, 'USD', true, '1.' + decimalCode) :
              this.decimalCurrent.transform(value, '1.' + decimalCode)
          )
      ) : '';
  }


}



// WEBPACK FOOTER //
// ./src/app/directives/currency-input/currency.directive.ts